import {SplitFileName} from '../../models/split-file-name.model';

export class StringUtils {
    public static splitFileName(fullName: string): SplitFileName {
        const lastDotIndex = fullName.lastIndexOf('.');
        if (lastDotIndex < 0) {
            return {
                baseName: fullName,
                extension: ''
            };
        }

        if (lastDotIndex === 0) {
            return {
                baseName: '',
                extension: fullName
            };
        }

        return {
            baseName: fullName.slice(0, lastDotIndex),
            extension: fullName.slice(lastDotIndex)
        };
    }

    public static stringToEnumObject<T extends string>(o: Array<T>): { [K in T]: K } {
        return o.reduce((res, key) => {
            res[key] = key;
            return res;
        }, Object.create(null));
    }

    public static transformToPascalCase(originalString: string): string {
        return StringUtils.getStringSegments(originalString)
            .map((stringSegment: string) => {
                return stringSegment.slice(0, 1)
                    .toUpperCase() + stringSegment.substring(1);

            })
            .join('');
    }

    public static transformToCamelCase(originalString: string): string {
        return StringUtils.getStringSegments(originalString)
            .map((stringSegment: string, index: number) => {
                if (index === 0) {
                    return stringSegment.toLowerCase();
                } else {
                    return stringSegment.slice(0, 1)
                        .toUpperCase() + stringSegment.substring(1);
                }
            })
            .join('');
    }

    public static transformToKebabCase(originalString: string): string {
        return StringUtils.getStringSegments(originalString)
            .join('-')
            .toLowerCase();
    }

    public static transformToSnakeCase(originalString: string): string {
        return StringUtils.getStringSegments(originalString)
            .join('_')
            .toLowerCase();
    }

    public static removeConsecutiveSlashes(url: string): string {
        return url.replaceAll(/(?<!:)\/\/+/g, '/');
    }

    private static getStringSegments(originalString: string): Array<string> {
        const matches = originalString.match(/([^\s\-_.A-Z]+)|([A-Z]+[^\s\-_.A-Z]*)/g);

        return matches ?? [];
    }
}
